module.exports = __webpack_public_path__ + "img/banner_wap.ecd9f1b4.png";